import { DesktopStatusFilter } from './components/DesktopStatusFilter';
import { MobileStatusFilter } from './components/MobileStatusFilter';
import { useStatusFilter } from './hooks/useStatusFilter';

type StatusFilterProps = {
	desktopView: boolean;
};

export const StatusFilter: React.FC<StatusFilterProps> = ({ desktopView }) => {
	const {
		data: { disabled, isAllPetitionsChecked, isVictoriesOnlyChecked, isTrendingChecked },
		actions: { setAllPetitions, setVictoriesOnly, trackStatusFilterClick, setTrending },
	} = useStatusFilter();

	if (desktopView) {
		return (
			<DesktopStatusFilter
				setAllPetitions={setAllPetitions}
				setVictoriesOnly={setVictoriesOnly}
				setTrending={setTrending}
				isAllPetitionsChecked={isAllPetitionsChecked}
				isVictoriesOnlyChecked={isVictoriesOnlyChecked}
				isTrendingChecked={isTrendingChecked}
				disabled={disabled}
				trackStatusFilterClick={trackStatusFilterClick}
			/>
		);
	}

	return (
		<MobileStatusFilter
			setAllPetitions={setAllPetitions}
			setVictoriesOnly={setVictoriesOnly}
			setTrending={setTrending}
			isAllPetitionsChecked={isAllPetitionsChecked}
			isVictoriesOnlyChecked={isVictoriesOnlyChecked}
			isTrendingChecked={isTrendingChecked}
			disabled={disabled}
			trackStatusFilterClick={trackStatusFilterClick}
		/>
	);
};
